const repaymentCalculator = require('./repayment-calculator.json');

/**
 * @typedef {Object} SalesVxRepaymentCalculator
 * No additional properties are allowed.
 * @property {number} loanAmount - The loan amount, must be a non-negative integer.
 * @property {number} rate - The interest rate, a decimal between 0 and 1 (e.g., 0.10 for 10%).
 * @property {number} term - The loan term in months (e.g., 360 for a 30-year loan).
 * @property {number} [balloon] - The balloon payment amount at the end of the loan term (optional).
 */

/**
 * Sales related validation schemas for vx-api
 * @module schemas/sales/vx
 * @property {SalesVxRepaymentCalculator} repaymentCalculator
 */
module.exports = {
  repaymentCalculator,
};
